import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import PageContainer from '../../layouts/PageContainer/PageContainer'
import RegularLayout from '../../layouts/Regular/Regular'
import Text from '../../components/Text/Text'
import * as styles from './ComingSoonPage.module.scss'

const ComingSoonPage = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const goBack = () => {
    history.goBack()
  }

  return (
    <RegularLayout pathname={pathname}>
      <PageContainer title="Coming soon" className={styles.comingSoon}>
        <Text>This site is being worked on. - this page is coming soon.</Text>

        <button
          className={styles.comingSoonButton}
          onClick={goBack}
          data-testid="coming-soon-page-button">
          Back
        </button>
      </PageContainer>
    </RegularLayout>
  )
}

export default ComingSoonPage
